export const permissionsCardStyles = {
  card: {
    width: 450,
    mb: 2,
    mr: 2,
    flexShrink: 0,
  },
  cardWrapper: {
    maxHeight: 500,
    overflow: 'auto',
    pb: 0,
    pt: 2,
    px: 1,
    mx: -1,
    mb: 2,
    borderRadius: '4px',
    border: '1px solid lightgray',
  },
  addCard: {
    padding: '8px !important',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  adminCard: {
    width: 450,
    padding: '8px !important',
    mb: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    border: '1px solid lightgray',
  },
};
